import React from 'react';
import { BaseChoose } from '@beisen/chaos-ui';
import * as html from '../util/html';
import * as helper from '../util/helper';
import { unvisibleButton } from '../util/unvisibleButton';
class ButtonChoose extends React.Component {
    constructor(props) {
        super(props);
    }

    chooseData() {
        return this.props.cmp_data.isSyncRowHandler ? this.props.rows[this.props.index]['sub_cmps']['buttonList']['sub_cmps']
              : this.props.rowButtonList.sub_cmps;
    }


    renderChoose() {
        const { rowButtonListClear,rowButtonTouchTap } = this.props;
        const chooseList = this.chooseData();
        const useableButtonFilter = item => item.cmp_data.visible && !item.cmp_data.disable && !unvisibleButton(item.cmp_data.action);
        const chooseListData = chooseList.filter(useableButtonFilter).map(item => {
            return { title: html.decode(item.cmp_data.title), dataObj: item, buttonId: item.cmp_id };
        });
        const { partId = '' } = helper.getQueryObject();
        return (<BaseChoose className={'chooseList'}
                           isShowChoose={true}
                           animation="bottom-slide-fade"
                           maskAnimation="fade"
                           onPanelClose={rowButtonListClear}
                           chooseList={chooseListData.reverse()}
                           onTouchTap={rowButtonTouchTap}
                           partId={partId || this.props.partId}
                           translation={this.props.translation}
                />);
    }

    render() {
        const { cmp_data,rowButtonList,isShowChoose } = this.props;
        if((cmp_data.isSyncRowHandler && isShowChoose) || rowButtonList) {
            return this.renderChoose();
        }
        return null;
    }

}

ButtonChoose.defaultProps = {
    cmp_data: {}
};
export default ButtonChoose;



// WEBPACK FOOTER //
// ./src/components/DataTable/ButtonChoose.js